module.exports = __webpack_public_path__ + "img/bike.8f077ea1.svg";